import { Dialog, Transition } from '@headlessui/react';
import { EnvelopeIcon } from '@heroicons/react/20/solid';
import React, { Fragment, useState } from 'react';

type Props = {
  callback: () => void;
};

const EmailRequired: React.FC<Props> = ({ callback }) => {
  const [open, setOpen] = useState(true);

  return (
    <Transition.Root show={open} as={Fragment} appear>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {
          setOpen(false);
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => {
            setOpen(false);
            callback();
          }}
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-error-container px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8  sm:p-6">
                <div className="bg-error-container px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                      <EnvelopeIcon className="text-error w-8 h-8" />
                    </div>
                    <h3
                      className="text-lg leading-6 font-medium text-on-error-container"
                      id="modal-headline"
                    >
                      Valid Email Needed
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm leading-5 text-on-error-container/80">
                        We use your email address to send the final receipt &
                        provide opportunities for feedback.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-error-container px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button
                      type="button"
                      className="inline-flex justify-center w-full rounded-md border border-primary/30 px-4 py-2 bg-primary text-base leading-6 font-medium text-on-primary shadow-sm hover:text-primary focus:outline-none focus:border-primary/50 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      Ok
                    </button>
                  </span>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    // <div className="fixed z-10 inset-0 overflow-y-auto">
    //   <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    //     <div className="fixed inset-0 transition-opacity">
    //       <div className="absolute inset-0 bg-gray-500 opacity-75" />
    //     </div>
    //     <span className="hidden sm:inline-block sm:align-middle sm:h-screen" />
    //     &#8203;
    //     <div
    //       className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
    //       role="dialog"
    //       aria-modal="true"
    //       aria-labelledby="modal-headline"
    //     >
    //       <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
    //         <div className="sm:flex sm:items-start">
    //           <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
    //             <svg
    //               className="h-6 w-6"
    //               xmlns="http://www.w3.org/2000/svg"
    //               fill="#000000"
    //               viewBox="0 0 512 512"
    //             >
    //               <path
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //                 strokeWidth="2"
    //                 fill="#000000"
    //                 d="m434.146 59.882h-389.234c-24.766 0-44.912 20.146-44.912 44.912v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159l-200.355 173.649-200.356-173.649c1.769-.736 3.704-1.159 5.738-1.159zm0 299.411h-389.234c-8.26 0-14.971-6.71-14.971-14.971v-251.648l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z"
    //               />
    //             </svg>
    //           </div>
    //           <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
    //             <h3
    //               className="text-lg leading-6 font-medium text-gray-900"
    //               id="modal-headline"
    //             >
    //               Valid Email Needed
    //             </h3>
    //             <div className="mt-2">
    //               <p className="text-sm leading-5 text-gray-500">
    //                 We use your email address to send the final receipt &
    //                 provide opportunities for feedback.
    //               </p>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
    //         <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
    //           <button
    //             type="button"
    //             className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
    //             onClick={callback}
    //           >
    //             Ok
    //           </button>
    //         </span>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default EmailRequired;
